import api from "../../ApiConfig";
import { Apis } from "../../../config";
import { NotificationManager } from "react-notifications";

const addProductList = async (data, config) => {
  try {
    let result = await api.post(Apis.AddProductList, data, config);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const addZipFiles = async (data, config) => {
  try {
    let result = await api.post(Apis.ZipUploads, data, config);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getAllProductList = async () => {
  try {
    let result = await api.get(Apis.GetAllProductList);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getUpdateProduct = async (data, config) => {
  try {
    let result = await api.post(Apis.GetUpdateProduct, data, config);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getDeleteProduct = async (id) => {
  try {
    let result = await api.delete(`${Apis.GetDeleteProduct}?id=${id}`); // Sending `id` through query in the URL
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getProductById = async (id) => {
  try {
    let result = await api.get(Apis.GetProductById, { params: { id } });
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getProductCount = async () => {
  try {
    let result = await api.get(Apis.GetAllProductCount);
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data; // Assuming the API response contains a `count` property
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getAdmProductListById = async (id) => {
  try {
    let result = await api.get(`${Apis.GetAdmProductListById}?id=${id}`);

    // Check for errors in the response
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    // Extract the productData from the response
    const productData = result.data.data;

    return { productData };
  } catch (error) {
    console.log("Error fetching product details:", error);
    return null;
  }
};

const createCategoryProductPDF = async (categoryId, categoryName) => {
  try {
    const data = { categoryId, categoryName };

    // Sending the data to the backend API
    let result = await api.post(Apis.CreateCategoryProductsPdf, data);

    // Check if there's an error in the response
    if (result.data.success) {
      return result.data; // Successful response
    } else {
      NotificationManager.error(result.data.msg || "Failed to create PDF");
      return null;
    }
  } catch (error) {
    console.log(error);
    NotificationManager.error("An error occurred while creating the PDF");
    return null;
  }
};

 const getAllProductQuerySearchList = async (q) => {
    try {
        let result = await api.get(Apis.GetProductQuerySearchList+q);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export default {
  addProductList,
  addZipFiles,
  getAllProductList,
  getUpdateProduct,
  getDeleteProduct,
  getProductById,
  getProductCount,
  getAdmProductListById,
  createCategoryProductPDF,
  getAllProductQuerySearchList,
};



// WEBPACK FOOTER //
// ./src/components/services/GetProductDetails/index.jsx